import React from "react";
import { useState, useEffect } from "react";
import { MdCode } from 'react-icons/md';
import { FaReact, FaBars } from 'react-icons/fa';
import { HiX } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import { useSpring, animated } from 'react-spring';
const Navbar = () => {
    const [toggleIcon, setToggleIcon] = useState(false)
    const [scale, setscale] = useState(false)

    const handleToggleIcon = () => {
        setToggleIcon(!toggleIcon)
    };
    const toggleScale = () => {
        setscale(!scale)
    };
    useEffect(() => {

const interval = setInterval(toggleScale,10000)
return ()=>clearInterval(interval)
    }, [scale]);
    const fadein = useSpring({
        transform: toggleIcon ? 'translateX(0)' : 'translateX(-100%)',
        opacity: toggleIcon ? 1 : 0,
        config: {
            duration: 500,
            delay: 500
        }
    })
    const rotate = useSpring({
        transform: toggleIcon ? 'rotate(360deg)' : 'rotate(180deg)',
        config: {
            duration: 500,
            delay: 500
        }

    })
    // const scaleAnim = useSpring({
    //     background: scale ? 'black' : 'auto',
    //     config: {
    //         duration: 500,
    //     }

    // })
    const data = [
        {
            label: 'HOME',
            to: '/'
        },
        {
            label: 'ABOUT ME',
            to: '/about'
        },
        {
            label: 'SKILLS',
            to: '/skills'
        },
        {
            label: 'SERVICES',
            to: '/services'
        },
        {
            label: 'PROJECTS',
            to: '/projects'
        }
        ,
        {
            label: 'CONTACT',
            to: '/contact'
        }
    ]
    return (
        <div className="h-[45px] md:h-[80px] w-full py-1 px-4">
            <nav className="navbar flex justify-between items-center  h-auto md:h-[70px] py-2 font-bold bg-white/30 backdrop-blur px-4 rounded-lg fixed right-0 w-full z-50">

                <div className="flex items-center w-full h-inherit ">
                    <Link to={'/'} reloadDocument className="">
                        <div className="text-yellow-500 font-extrabold text-xl md:text-3xl font-mono border-l-4 border-b-2 rounded-full px-2">UDO<span className="text-white">KA</span></div>
                    </Link>
                </div>
                <ul className=" w-full md:flex justify-between hidden">
                    {
                        data.map((item, key) => (
                            <li key={key} >
                                <Link to={item.to} reloadDocument className="text-yellow-500 after:content[] after:block after:h-[3px] after:w-0 after:bg-transparent after:transition-all after:ease-out after:0.5s hover:after:w-full hover:after:bg-yellow-500">
                                    {item.label}
                                </Link>
                            </li>
                        ))
                    }
                </ul>
            <Link to="/hireMe" reloadDocument className={scale?"py-2 px-2 rounded-lg bg-yellow-500 text-white font-bold w-40 text-center mx-8":"py-2 px-2 rounded-lg bg-black/30 border scale-110 duration-1000 ease-in-out text-white font-bold w-40 text-center mx-8"}>Hire Me</Link>
                <animated.div style={rotate} onClick={handleToggleIcon} className="text-yellow-500 md:hidden">
                    {
                        toggleIcon ? <HiX size={30} /> : <FaBars size={30} />
                    }
                </animated.div>
                <animated.div style={fadein} className="absolute z-50 bg-white/90 w-full h-screen py-8 flex justify-center left-0 top-[50px]">
                    <ul className="flex flex-col space-y-8">
                        {
                            data.map((item, key) => (
                                <li key={key} >
                                    <Link reloadDocument onClick={handleToggleIcon} to={item.to} className="text-yellow-700 after:content[] after:block after:h-[3px] after:w-0 after:bg-transparent after:transition-all after:ease-out after:0.5s hover:after:w-full hover:after:bg-yellow-500">
                                        {item.label}
                                    </Link>
                                </li>
                            ))
                        }
                    </ul>
                </animated.div>
            </nav>
        </div>
    );
}

export default Navbar;